import { useTranslation } from 'react-i18next';
import { benefits } from '@/mocks/benefits';

export default function Benefits() {
  const { t } = useTranslation();

  return (
    <section id="beneficios" className="py-16 md:py-20 lg:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-accent-600 font-semibold text-sm uppercase tracking-wider mb-3">
              Nossos Serviços
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
              {t('benefits.title')}
            </h2>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
              {t('benefits.subtitle')}
            </p>
          </div>

          {/* Cards grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {benefits.map((benefit, index) => (
              <div
                key={benefit.id}
                className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 hover:-translate-y-1"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Image */}
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <img
                    src={benefit.image}
                    alt={benefit.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/50 to-transparent" />
                  {/* Icon badge */}
                  <div className="absolute bottom-3 left-4 w-10 h-10 bg-accent-500 rounded-md flex items-center justify-center shadow-lg">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className={`${benefit.icon} text-background-50 text-lg`} />
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 md:p-5">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    {benefit.description}
                  </p>
                  <button
                    onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
                    type="button"
                  >
                    {t('benefits.cta')}
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </div>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}